import Image from "next/image";
import React from "react";

import Paragraph from "../Paragraph/Paragraph";
import styles from "./PictureTextRight.module.scss";

const PictureTextRight = ({
  imageUrl,
  imageAlt,
  paragraphTitle,
  paragraphContent,
  imageOrder = 1,
  textOrder = 2,
  imageWidth,
  imageHeight,
}) => {
  return (
    <div className={styles.pictureTextContainer}>
      <div className={styles.imageWrapper} style={{ order: imageOrder }}>
        <Image
          src={imageUrl}
          alt={imageAlt}
          width={imageWidth}
          height={imageHeight}
          className={styles.image}
        />
      </div>
      <div className={styles.textContainer} style={{ order: textOrder }}>
        <Paragraph title={paragraphTitle} content={paragraphContent} />
      </div>
    </div>
  );
};

export default PictureTextRight;
